import { inject, Injectable } from "@angular/core";

import { timer } from "rxjs";

import { CustomWindow } from "@shared/models";
import { GlobalService } from "@shared/services";

declare let window: CustomWindow;

@Injectable({
  providedIn: "root",
})
export class FontService {
  globalService = inject(GlobalService);

  init(): void {
    timer(0, 1000).subscribe(() => {
      if (window.userFontSize) {
        this.globalService.isApaApp.set(true);
        this.globalService.fontSize.set(window.userFontSize);
      }
    });
  }
}
